const $locationInfo = $('.location__info');
const $locationAbout = $('.location__coordinator');
const $locationTabs = $('.location-tabs');
const $navLink = $('.location-tabs__item--anchor');
const $mobileCollapse = $('.location-tabs__item--mobile');
const $hiddenFilters = $('.location-tabs__item--hidden');
const $col4 = $('.col-md-4');

/**
 * Is responsible for the location tabs and the animation
 * of the the contact sidebar
 */
export class LocationPage {
  constructor() {
    this.$locationTabs = $('.location-tabs');
    this.$navLink = $('.location-tabs__item--anchor');
    this.$mobileCollapse = $('.location-tabs__item--mobile');
    this.$formButton = $('#contact_aanvragen_button');

    if (this.$locationTabs.length === 0) {
      return;
    }

    // initial title of the mobile dropdown menu
    this.showMoreTitle = $mobileCollapse.text();

    // initial position of the static filter bar below the header
    this.minScollOffset = (($('.location-tabs--static').offset().top)-($('.header-bar').height() + $('.user-bar').height()));

    // distance the contact sidebar will translate when scrolling down
    this.transition = $locationAbout.offset().top - $locationInfo.offset().top;

    // bind events
    this.$navLink.on('click', (e) => this.onNavItemClicked(e));
    this.$mobileCollapse.on('click', e => this.mobileCollapseToggle(e));
    this.$formButton.on('click', e => this.formModal(e));
    $(window).on('scroll', () => this.scrollCheck());

    // match the height of the coordinator story and the contact sidebar
    this.scrollCheck();
    this.matchHeight();
    this.populateField();
    this.hideOptions();

    // Get all the h3 elements with the class 'product-list__title'
    const sections = $('.product-list__title');

    // Listen for scroll events
    $(window).scroll(() => this.onScroll(sections));
  }

  /**
   * Handle scroll events
   * @param {jQuery} sections - jQuery collection of h3 elements
   */
  onScroll(sections) {
    // Get the current scroll position
    const currentPosition = $(window).scrollTop();

    // Get the offset top of the first h3 element
    const firstSectionTop = sections.first().offset().top - 350; // Adjust the offset as needed

    // Check if the current scroll position is below the top of the first h3 element
    if (currentPosition <= firstSectionTop) {
      // Remove the 'location-tabs__item--active' class from all <a> elements
      $navLink.removeClass('location-tabs__item--active');
    } else {
      // Loop through each h3 element
      sections.each(function () {
        // Get the offset top of the h3 element
        const top = $(this).offset().top - 350; // Adjust the offset as needed

        // Check if the current scroll position is past the h3 element
        if (currentPosition >= top) {
          // Get the id attribute of the h3 element
          const id = $(this).attr('id');

          // Remove the 'location-tabs__item--active' class from all <a> elements
          $navLink.removeClass('location-tabs__item--active');

          // Add the 'location-tabs__item--active' class to the <a> element with the corresponding href
          $(`a[href="#${id}"]`).addClass('location-tabs__item--active');
        }
      });
    }
  }

  /**
   * Scroll to the required section
   * @param e
   */
  onNavItemClicked(e) {
    e.preventDefault();
    const $item = $(e.currentTarget);
    const section = $item.attr('href');
    const $item_active = $('a[href="'+section+'"]');
    const offset = $(section).offset().top - 250;

    $navLink.removeClass('location-tabs__item--active');
    $item_active.addClass('location-tabs__item--active');

    // Scroll to the id with animation
    $('html, body').stop().animate({ scrollTop: offset }, 500);

    // collapse the menu
    this.mobileCollapseToggle(e);
  }


  /**
   * Collapse the mobile menu
   * @param e
   */
  mobileCollapseToggle(e) {
    e.preventDefault();
    if ($(window).width() > 767) {
      return;
    }

    $mobileCollapse.toggleClass('active');
    $hiddenFilters.toggle();

    if ($mobileCollapse.hasClass('active')) {
      $mobileCollapse.text('Navigatie verbergen');
    } else {
      $mobileCollapse.text(this.showMoreTitle);
    }
  }

  /**
   * Make filter bar sticky on scroll
   * Also animates the contact sidebar/.location__info
   */
  scrollCheck() {
    if ($(window).width() < 991) {
      //const newListItem = $('<li class="location-tabs__item visible-xs"><div class="location-tabs__item--mobile">Meer ' + post.post_title + '</div></li>');
      //this.$locationTabs.addClass('__item--mobile');
      //this.$locationTabs.append(newListItem);

      this.$col4.removeClass('col-md-4');

      return;
    }

    const locationTabsRow = $('.row.hidden-xs.location-tabs--static');
    const locationTabsOffset = locationTabsRow.offset().top;
    const scrollPosition = $(window).scrollTop();

    if (scrollPosition >= locationTabsOffset) {
      this.$locationTabs.addClass('location-tabs--fixed');
    } else {
      this.$locationTabs.removeClass('location-tabs--fixed');
    }
  }

  /**
   * Make the coordinator story the same height as the sidebar
   */
  matchHeight() {
    if ($(window).width() < 991) {
      return;
    }

    if ($locationAbout.innerHeight() > 400) {
      this.orginalInfoHeight = $locationInfo.innerHeight();
      this.aboutHeight = $locationAbout.innerHeight();
    }
  }

  /**
   * Open form in modal
   */
  formModal(e){
    e.preventDefault();
    $('.contact_aanvragen').modal('show');
  }

  /**
   * Automatic populate de location id  and lead owner fields
   */
  populateField() {
    let location_id = $("meta[itemProp=location_id]")
      .attr("content");
    $('.location_id_field input')
      .val(location_id);
    let is_hub = $("meta[itemProp=is_hub]")
      .attr("content");
    if (is_hub == 0) {
      $('.lead_owner_field input')
        .val('2'); // schoollocatie -> naar klantenservice
    } else {
      $('.lead_owner_field input')
        .val('1'); // schoollocatie -> naar klantenservice
    }

  }

  /**
   * Hide the product options that are not available in the current location
   */
  hideOptions(){
    $('.location_products_field select option:not(:first)').hide();
    $('.product-list .product-list__item .product-list__title').each(function(){
      let tabItem = $(this).attr('id');
      $('.location_products_field select option').each(function(){
        let optionText = $(this).attr('value');
        if ( optionText === tabItem ) {
          $(this).show();
        }
      });
    });
  }
}
